import styled from '@emotion/styled'

export const StyleWrapper = styled.div`
  height: 100vh;
  overflow-y: auto;
`

export const StyleBackDropWrapper = styled.div`
  position: fixed;
  z-index: 111;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const StyleModalWrapper = styled.div`
  background: white;
  width: 30%;
  padding: 20px 15px;
  border-radius: 12px;
`
